import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { IMessagesTemplate } from "@/types/messages-template.type";

const API_URL = `${import.meta.env.VITE_API_URL}/marketing`;
const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getAllMessageTemplates(cursor?: string) {
  const url = new URL(`${API_URL}/message-templates`);
  if (cursor) {
    url.searchParams.append("cursor", cursor);
  }

  const result = (await makeRequestDebounced(url.toString())) as ApiResponseType<{ ok: boolean, data: {
    name: string, 
    id: string,
    components: {
      type: string, 
      text: string
    }
  }[], message: string, cursor: string}>;

  return result;
}

export async function createMessageTemplate(data: IMessagesTemplate) {
  const url = `${API_URL}/message-templates`;

  const result = (await makeRequest(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })) as ApiResponseType<{ ok: boolean, data: unknown, message: string}>;

  return result;
}

export async function deleteMessageTemplates(name: string) {
  const url = `${API_URL}/message-templates`

  const result = (await makeRequest(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name }),
  })) as ApiResponseType<{ ok: boolean, data: Record<string, string>, message: string}>;

  return result;
}
